import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  variant?: 'default' | 'featured' | 'compact';
}

export default function VideoCard({ video, variant = 'default' }: VideoCardProps) {
  const isFeatured = variant === 'featured';
  const isCompact = variant === 'compact';

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${isFeatured ? 'aspect-[21/9]' : 'aspect-video'} bg-background-200`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 棒棒TV免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          {isFeatured && (
            <span className="inline-block px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded mb-2 whitespace-nowrap">
              推荐
            </span>
          )}
          <div className="flex items-center gap-2 text-white/80 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {video.rating}
            </span>
            <span>{video.year}</span>
            {!isCompact && <span>{video.duration}</span>}
          </div>
        </div>
        {video.latest && (
          <div className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded whitespace-nowrap">
            新
          </div>
        )}
      </div>

      {!isCompact && (
        <div className="mt-2 md:mt-3">
          <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap">
            {video.title}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-500">{video.views}次播放</span>
            <span className="text-xs text-foreground-400">·</span>
            <span className="text-xs text-foreground-500">{video.category}</span>
          </div>
        </div>
      )}
    </Link>
  );
}